import { useForm } from "react-hook-form";
import {
	Button,
	Box,
	HStack,
	Text,
	VStack,
	Grid,
	useToast,
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogFooter,
	AlertDialogBody,
	useDisclosure,
	Flex,
} from "@chakra-ui/react";

import { toastGenerator } from "../../../../utils/helper";
import { PasswordControl } from "../../../../components/Controls";
import { useChangePasswordeUser, invalidateUserQuery } from "../../../../utils/hooks/users";
import { useEffect } from "react";
import { useAuth } from "../../../../plugins/CookieAuthPlugin";
export default function ChangePassword() {
	const toast = useToast();
	const {
		user: { statusLogin, id },
		logout,
	} = useAuth();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { handleSubmit, control, getValues, reset } = useForm();

	const changePassword = useChangePasswordeUser({
		onSuccess(data) {
			let status = data.header.result;
			toast(toastGenerator({ status: status ? "success" : "warning" }));
			invalidateUserQuery();
			reset({});
			status && onOpen();
		},
	});

	useEffect(() => {
		statusLogin === 1 &&
			toast({
				title: "Consider Changing your pawword",
				description: "Please change your password before using system",
				status: "info",
				fontSize: "sm",
				duration: 3000,
				variant: "subtle",
				position: "top",
			});
		//eslint-disable-next-line
	}, []);
	const onSubmit = (values) => {
		if(id === "7"){
			toast(toastGenerator({ status: "warning", message: "Can't edit this user" }));
			return;
		}
		let formData = new FormData();
		formData.append("oldPassword", values.oldPassword);
		formData.append("newPassword", values.newPassword);
		changePassword.mutate(formData);
	};

	function StayOnPage() {
		return (
			<AlertDialog motionPreset="slideInBottom" onClose={onClose} isOpen={isOpen} isCentered closeOnEsc={false}>
				<AlertDialogOverlay />

				<AlertDialogContent>
					<AlertDialogHeader fontSize="lg" textAlign={"center"}>
						You are about to be logged out of JTI Login
					</AlertDialogHeader>
					<AlertDialogBody justifyContent={"center"} alignItems="center">
						<Flex justifyContent={"center"}>
							<Button
								colorScheme="brand"
								onClick={() => {
									window.location.href = "/work-permit";
								}}
								ml={3}
							>
								No, stay logged in!
							</Button>
							<Button
								colorScheme="red"
								onClick={() => {
									logout();
								}}
								ml={3}
							>
								Log me out
							</Button>
						</Flex>
					</AlertDialogBody>
					<AlertDialogFooter />
				</AlertDialogContent>
			</AlertDialog>
		);
	}
	return (
		<Box bg="white" minH="full" rounded="md">
			{StayOnPage()}
			<form onSubmit={handleSubmit(onSubmit)}>
				<Grid templateColumns="auto max-content" p="3" mb="3" boxShadow="sm">
					<Grid templateColumns="max-content" gap="2" alignContent="center">
						<Text ml="2" fontSize="lg" fontWeight="semibold">
							Change Password
						</Text>
					</Grid>
					<Grid>
						<HStack>
							<Button type="submit" colorScheme="redAlt" variant="duotone">
								Update
							</Button>
						</HStack>
					</Grid>
				</Grid>
				<Grid py="2" templateColumns="repeat(3,1fr)" gap="4" p="3">
					<VStack spacing="6">
						<PasswordControl
							name="oldPassword"
							label="Current Password"
							placeholder="Enter Password"
							control={control}
							isRequired
							rules={{
								minLength: {
									value: 8,
									message: "Password must have at least 8 characters",
								},
							}}
						/>
						<PasswordControl
							name="newPassword"
							label="New Password"
							placeholder="Enter Password"
							control={control}
							isRequired
							rules={{	
								pattern: {
									value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
									message: "Password must have one UpperCase, at least 8 characters and One Special Character",
								},
							}}
						/>
						<PasswordControl
							name="reTypePassword"
							label="Retype-Password"
							placeholder="Retype-Password"
							control={control}
							rules={{
								validate: (value) => {
									return value === getValues("newPassword") || "Password does not match";
								},
							}}
						/>
					</VStack>
				</Grid>
			</form>
		</Box>
	);
}
